import React from 'react';
import { ShieldCheck, ShieldAlert } from 'lucide-react';

interface VettingBadgeProps {
  vetted: boolean;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
}

export default function VettingBadge({ vetted, size = 'md', showIcon = true }: VettingBadgeProps) {
  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5 gap-1',
    md: 'text-xs px-2.5 py-1 gap-1.5',
    lg: 'text-sm px-3 py-1.5 gap-2',
  };

  const iconSize = { sm: 12, md: 13, lg: 15 };

  if (vetted) {
    return (
      <span className={`inline-flex items-center font-semibold rounded-full vetted-badge ${sizeClasses[size]}`}>
        {showIcon && <ShieldCheck size={iconSize[size]} />}
        Vetted
      </span>
    );
  }

  return (
    <span className={`inline-flex items-center font-semibold rounded-full unvetted-badge ${sizeClasses[size]}`}>
      {showIcon && <ShieldAlert size={iconSize[size]} />}
      Not vetted
    </span>
  );
}